export default [
  {
    path: '/template/role',
    name: 'roleTemplate',
    component: () => import('@/views/template/roleTemplate.vue'),
    meta: { title: '角色模板' }
  },
  {
    path: '/template/business',
    name: 'businessTemplate',
    component: () => import('@/views/template/businessTemplate.vue'),
    meta: { title: '厂商模板' }
  }
]
